export const removeSpacesFromString = (str: string): string => {
  return str.split(" ").join("");
};
